import { render, staticRenderFns } from "./RelatorioLogComunicacaoForm.vue?vue&type=template&id=76959bd8&scoped=true&"
import script from "./RelatorioLogComunicacaoForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioLogComunicacaoForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioLogComunicacaoForm.vue?vue&type=style&index=0&id=76959bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76959bd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
